module.exports = __webpack_public_path__ + "img/netgear.9b1c71c6.svg";